import './history.scss';

// let element = $('.years_list > ul > li');
//
// element.click(function (e) {
//   e.preventDefault();
//
//   element.removeClass('active');
//   $(this).addClass('active');
//
//   let $el_link = $(this).find('a').attr('href');
//   let all_category_el = $('.category');
//
//   all_category_el.removeClass('active');
//
//   $('html, body').stop().animate({
//     scrollTop: $($el_link).offset().top - 20
//   }, 500, () => {
//     $($el_link).addClass('active');
//   });
//
// });

$.fn.isInViewport = function() {
  let elementTop = $(this).offset().top;
  let elementBottom = elementTop + $(this).outerHeight();
  let windowHeight = $(window).height();
  let gridTop = $(window).scrollTop() + windowHeight * .2;
  let gridBottom = $(window).scrollTop() + windowHeight * .5;
  return elementTop >= gridTop && elementBottom <= gridBottom;
};

function historySpy() {
  let sections = $('.event-list .category');
  let current;

  sections.removeClass('active');

  sections.each(function() {
    if ($(this).isInViewport()) {
      current = $(this).attr('id');
    }
  });

  $('.event-list .category#'+current).addClass('active');

  $('.years_list a[href="#'+current+'"]').closest('li').addClass('active');
  $('.years_list a').not('a[href="#'+current+'"]').closest('li').removeClass('active');
}

//scrollSpy call
$(document).ready( function() {
  // smooth scrolling navigation
  $('.years_list a').click( function() {
    let target = $(this).attr('href');

    $('.event-list .category').removeClass('active');

    $('body, html').animate({
      scrollTop: $(target).offset().top - ($(window).height() * .35)
    }, 300);

    $('.event-list .category#'+target.replace('#', '')).addClass('active');

    return false;
  });

  historySpy();
});

$(window).scroll( function() {
  historySpy();
});
